import { get, postJson } from "../../../hook/request";
import type { AxiosResponse } from "axios";
import { TodoFilter } from "../context/TodoFilterContext";
import {
  TodoListApiResponse,
  TodoApiItem,
  TodoListType,
  CreateTaskResponse,
  TodoListResult
} from "./type";

function mapTodoApiItem(item: TodoApiItem): TodoListType {
  return {
    id: item.ID,
    userID: item.userID,
    testo: item.testo,
    completato: item.completato,
    cancellato: item.cancellato,
    data: item.data,
    data_comp: item.data_comp,
    data_canc: item.data_canc,
  };
}

export async function getTaskList(filter: TodoFilter): Promise<TodoListResult> {
  const res: AxiosResponse<TodoListApiResponse> = await get(
    `/task/list?filter=${filter}`
  );

  const data = res.data;
  if (data.status !== "ok") {
    return {
      list: [],
      totale: 0,
      completato: 0,
      cancellati: 0,
    };
  }

  return {
    list: data.list.map(mapTodoApiItem),
    totale: data.totale,
    completato: data.completato,
    cancellati: data.cancellati,
  };
}


export async function createTask(input: { testo: string }): Promise<CreateTaskResponse> {
  const res: AxiosResponse<CreateTaskResponse> = await postJson("task/new", input);
  return res.data;
}

export async function toggleTaskComplete(input: {id: number; completato: 0 | 1; }): Promise<CreateTaskResponse> {
  const res: AxiosResponse<CreateTaskResponse> = await postJson("/task/complete", input);
  return res.data;
}
